import React, { useEffect } from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import {
    LoadingDots,
} from 'wanderu-components';
import { liveCheckEvents } from 'wanderu-components-search';
import {
    localize,
} from 'wanderu-i18n';

import styles from './Price.scss';

function Price(props) {
    const {
        className = '',
        funnelStage,
        i18nMoney,
        liveChecksInProgress = false,
        pricing,
        t,
        totalDiscount,
        tripId,
    } = props;

    const totalPrice = pricing
        ? i18nMoney.format(i18nMoney(pricing).getTotalPrice())
        : '';

    useEffect(() => {
        if (liveChecksInProgress && funnelStage === 'trip_summary') {
            liveCheckEvents.liveCheckInProgressViewed({
                funnelStage,
                originalPrice: totalPrice,
                tripId,
                uiViewed: 'price-loading-animation',
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [liveChecksInProgress]);

    return (
        <div className={className}>
            {liveChecksInProgress
                ? (
                    <LoadingDots className={styles.loadingDots} />
                )
                : (<>
                    {!!totalDiscount && <span
                        aria-label={t('baseApp:price')}
                        aria-live="polite"
                        className={styles.discounted}
                    >
                        {pricing
                            ? i18nMoney.format(i18nMoney(pricing).getTotalPrice() + totalDiscount)
                            : ''}
                    </span>}
                    <span
                        aria-label={t('baseApp:price')}
                        aria-live="polite"
                        className={classNames(styles.amount, {
                            [styles.slash]: !!totalDiscount,
                        })}
                    >
                        {totalPrice}
                    </span>
                </>
                )}
        </div>
    );
}

Price.propTypes = {
    className: PropTypes.string,
    funnelStage: PropTypes.string,
    i18nMoney: PropTypes.func,
    liveChecksInProgress: PropTypes.bool,
    pricing: PropTypes.arrayOf(PropTypes.object),
    t: PropTypes.func,
    totalDiscount: PropTypes.number,
    tripId: PropTypes.string,
};

export {
    Price,
};
export default localize(Price, ['t', 'i18nMoney']);
